import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onReset?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  actionTo,
  onReset,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6 bg-background-100 rounded-lg border border-dashed border-background-300">
      <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mb-5">
        <i className={`${icon} text-3xl text-foreground-400`} />
      </div>
      <h3 className="font-heading text-lg font-bold text-foreground-900">{title}</h3>
      {description && <p className="text-sm text-foreground-500 mt-2 max-w-sm">{description}</p>}
      <div className="flex items-center gap-3 mt-6">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="px-5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            重置筛选
          </button>
        )}
        {actionTo && (
          <Link
            to={actionTo}
            className="px-5 h-10 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center"
          >
            {actionLabel || "返回首页"}
          </Link>
        )}
      </div>
    </div>
  );
}